import React from 'react';
export function SingleDivider() {
  return <div className="py-4" data-id="element-485">
      <div className="max-w-7xl mx-auto px-4" data-id="element-486">
        <div className="h-[5px] bg-gradient-to-r from-transparent via-[#E87B5C] to-transparent rounded-full" data-id="element-487"></div>
      </div>
    </div>;
}